import React, { useEffect, useState } from "react";

// Animated donut chart. segments: [{ label, value(number), color }].
export default function DonutChart({ segments = [], size = 168, centerTop, centerSub }) {
  const [grow, setGrow] = useState(0);
  useEffect(() => {
    const id = requestAnimationFrame(() => setGrow(1));
    return () => cancelAnimationFrame(id);
  }, [segments]);

  const total = segments.reduce((s, x) => s + (x.value || 0), 0);
  const stroke = 18;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const cx = size / 2;

  let offset = 0;
  const arcs = segments.map((seg, i) => {
    const frac = total > 0 ? (seg.value || 0) / total : 0;
    const len = frac * c * grow;
    const el = (
      <circle
        key={i}
        cx={cx}
        cy={cx}
        r={r}
        fill="none"
        stroke={seg.color}
        strokeWidth={stroke}
        strokeLinecap="butt"
        strokeDasharray={`${len} ${c - len}`}
        strokeDashoffset={-offset}
        className="donut-seg"
        transform={`rotate(-90 ${cx} ${cx})`}
      />
    );
    offset += frac * c * grow;
    return el;
  });

  return (
    <div className="donut" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle cx={cx} cy={cx} r={r} fill="none" stroke="rgba(120,160,255,0.10)" strokeWidth={stroke} />
        {total > 0 ? arcs : null}
      </svg>
      <div className="donut-center">
        <div className="donut-top">{centerTop}</div>
        {centerSub ? <div className="donut-sub">{centerSub}</div> : null}
      </div>
    </div>
  );
}
